"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDUCER_KEY = exports.upsertResources = void 0;
const redux_actions_1 = require("redux-actions");
const immutable_1 = require("immutable");
const core_actions_1 = require("companion-app-components/flux/core-actions");
const actions = __importStar(require("./actions"));
const types_1 = require("./types");
function upsertResources(state, payeesByAccountId) {
    let resources = state.payeesByAccountId;
    payeesByAccountId.forEach((res, key) => {
        resources = resources.set(key, res);
    });
    return state.set('payeesByAccountId', resources).set('loadPending', false);
}
exports.upsertResources = upsertResources;
const reducer = (0, redux_actions_1.handleActions)({
    [core_actions_1.coreActions.sanitize.toString()]: (state) => state.set('payeesByAccountId', state.payeesByAccountId.map((resources) => resources.mapEntries(([id, resource]) => {
        const hashedTxn = resource.txn
            ? resource.txn.merge(Object.assign(Object.assign({ payee: (0, immutable_1.hash)(resource.txn.payee).toString(), memo: (0, immutable_1.hash)(resource.txn.memo).toString() }, (resource.txn.check && {
                check: { memo: (0, immutable_1.hash)(resource.txn.check.memo).toString() },
            })), (resource.txn.cpData && {
                cpData: {
                    payee: (0, immutable_1.hash)(resource.txn.cpData.payee).toString(),
                    inferredPayee: (0, immutable_1.hash)(resource.txn.cpData.inferredPayee).toString(),
                    memo: (0, immutable_1.hash)(resource.txn.cpData.memo).toString(),
                },
            })))
            : undefined;
        const sanitizedResource = resource.merge(Object.assign({ name: (0, immutable_1.hash)(resource.name).toString(), catString: (0, immutable_1.hash)(resource.catString).toString(), tagString: (0, immutable_1.hash)(resource.tagString).toString() }, (hashedTxn ? { txn: hashedTxn } : {})));
        return [(0, immutable_1.hash)(id).toString(), sanitizedResource];
    }))),
    [actions.updatePayeeListAsync.toString()]: (state, data) => {
        setTimeout(() => {
            data.asyncDispatch(actions.updatePayeeList(data.payload));
        }, 3000);
        return state;
    },
    [actions.updatePayeeList.toString()]: (state) => state,
    [actions.createPayeeList.toString()]: (state) => state,
    [actions.updatePayeeListSuccess.toString()]: (state, { payload: data }) => upsertResources(state, data),
    [actions.createPayeeListSuccess.toString()]: (state, { payload: data }) => upsertResources(state, data),
    [actions.updatePayeeListFailure.toString()]: (state, { payload: _error }) => state,
    [actions.createPayeeListFailure.toString()]: (state, { payload: _error }) => state,
}, (0, types_1.mkPayeeListStore)());
exports.REDUCER_KEY = 'payeeListStore';
exports.default = reducer;
